<template>
  <div class="level-management">
    <!-- 列表页 -->
    <div v-if="!showForm">
      <div class="level-header">
        <h3 class="level-title">员工等级管理</h3>
        <el-button type="primary" @click="handleAdd" v-has="'staff:level:add'">+ 添加等级</el-button>
      </div>
      <div class="level-content">
        <div class="box_list" v-if="dataList && dataList.length">
          <div class="box_item" v-for="(item, index) in dataList" :key="index">
            <p class="title">{{item.levelName}}</p>
            <div class="icon">
              <img :src="item.levelIcon" v-if="item.levelIcon" />
            </div>
            <p class="line"></p>
            <div class="bottom_msg">等级权益<span>{{ item.benefits ? item.benefits.length : 0 }}</span></div>
            <!-- <div class="bottom_msg">等级员工数<span>{{ item.staffCount || 0 }}</span></div> -->
            <p class="bottom_line"></p>
            <div class="bottom_btns">
              <p class="btn edit" @click="handleEdit(item)" v-has="'staff:level:edit'">编辑</p>
              <p class="center_line"></p>
              <p class="btn" @click="handleDelete(item)" v-has="'staff:level:delete'">删除</p>
            </div>
          </div>
        </div>
        <el-empty v-else description="暂无等级数据" />
      </div>
    </div>

    <!-- 添加/编辑表单页 -->
    <div v-else class="form-page">
      <el-form :model="formData" :rules="formRules" ref="formRef" label-width="120px">
        <!-- 基础信息 -->
        <div class="section">
          <h3 class="section-title">基础信息</h3>
          <el-form-item label="等级名称：" prop="levelName">
            <el-input v-model="formData.levelName" placeholder="请输入等级名称" style="width: 320px"></el-input>
          </el-form-item>
          <el-form-item label="等级标识：">
            <upload-img
              :isAdd="true"
              :fileList="levelIconFileList"
              @handleUploadSuccess="handleIconUploadSuccess"
              @handleUploadRemove="handleIconUploadRemove"
              ref="uploadIconRef"
              :limit="1">
            </upload-img>
          </el-form-item>
          <el-form-item label="技能认证：" prop="skillCertification">
            <el-select v-model="formData.skillCertification" placeholder="请选择" style="width: 320px">
              <el-option label="初级认证" :value="1"></el-option>
              <el-option label="中级认证" :value="2"></el-option>
              <el-option label="高级认证" :value="3"></el-option>
              <el-option label="首席认证" :value="4"></el-option>
              <el-option label="专家认证" :value="5"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <!-- 升级规则 -->
        <div class="section">
          <h3 class="section-title">升级规则</h3>
          <p class="section-desc">每季度业绩产出目标</p>
          <el-form-item label="消耗收入 (3)" prop="targetConsumeIncome">
            <el-input v-model.number="formData.targetConsumeIncome" placeholder="请输入" style="width: 320px" type="number"></el-input>
          </el-form-item>
          <el-form-item label="有效客户数 (2)" prop="targetActiveCustomers">
            <el-input v-model.number="formData.targetActiveCustomers" placeholder="请输入" style="width: 320px" type="number"></el-input>
          </el-form-item>
          <el-form-item label="售卡收入 (1)" prop="targetCardIncome">
            <el-input v-model.number="formData.targetCardIncome" placeholder="请输入" style="width: 320px" type="number"></el-input>
          </el-form-item>
        </div>

        <!-- 权益内容 -->
        <div class="section">
          <h3 class="section-title">权益内容</h3>
          <p class="section-desc">配置该等级员工可享有的系统权限与职业认证权益</p>
          <div class="benefits-list">
            <div class="benefit-item" v-for="(item, index) in formData.benefits" :key="index">
              <div class="benefit-name">{{ item }}</div>
              <div class="benefit-tag">可申请</div>
              <el-icon class="benefit-remove" @click="removeBenefit(index)"><Close /></el-icon>
            </div>
            <div class="benefit-item add-benefit" @click="handleAddBenefit">
              <span>+</span>
              <span>添加权益</span>
            </div>
          </div>
        </div>
      </el-form>

      <div class="form-footer">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleSubmit">保存设置</el-button>
      </div>
    </div>

    <!-- 添加权益弹窗 -->
    <el-dialog v-model="benefitDialogVisible" title="添加权益" width="400px">
      <el-input v-model="newBenefit" placeholder="请输入权益名称"></el-input>
      <template #footer>
        <el-button @click="benefitDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmAddBenefit">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script lang="js">
import { defineComponent, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { Close } from '@element-plus/icons-vue'
import { popup } from '@/utils/pop-up'
import UploadImg from '@/components/page-upload/upload-img/upload-img.vue'
import {
  getStaffLevelList,
  saveStaffLevel,
  updateStaffLevel,
  deleteStaffLevel
} from '@/service/main/staff'

export default defineComponent({
  name: 'levelManagement',
  components: { Close, UploadImg },
  setup() {
    const dataList = ref([])
    const showForm = ref(false)
    const formRef = ref(null)
    const uploadIconRef = ref(null)
    const currentEditId = ref(null)
    const levelIconFileList = ref([])

    const getDefaultFormData = () => ({
      levelName: '',
      levelIcon: '',
      skillCertification: '',
      targetConsumeIncome: '',
      targetActiveCustomers: '',
      targetCardIncome: '',
      benefits: []
    })

    const formData = ref(getDefaultFormData())

    const formRules = {
      levelName: [{ required: true, message: '请输入等级名称', trigger: 'blur' }],
      skillCertification: [{ required: true, message: '请选择技能认证', trigger: 'change' }],
      targetConsumeIncome: [{ required: true, message: '请输入消耗收入', trigger: 'blur' }],
      targetActiveCustomers: [{ required: true, message: '请输入有效客户数', trigger: 'blur' }],
      targetCardIncome: [{ required: true, message: '请输入售卡收入', trigger: 'blur' }]
    }

    // 图标上传
    const handleIconUploadSuccess = (res) => {
      formData.value.levelIcon = res.data.uri
    }

    const handleIconUploadRemove = () => {
      formData.value.levelIcon = ''
    }

    // 权益相关
    const benefitDialogVisible = ref(false)
    const newBenefit = ref('')

    const handleAddBenefit = () => {
      newBenefit.value = ''
      benefitDialogVisible.value = true
    }

    const confirmAddBenefit = () => {
      if (!newBenefit.value.trim()) {
        ElMessage.warning('请输入权益名称')
        return
      }
      formData.value.benefits.push(newBenefit.value.trim())
      benefitDialogVisible.value = false
    }

    const removeBenefit = (index) => {
      formData.value.benefits.splice(index, 1)
    }

    // 列表
    const getDataList = async () => {
      let res = await getStaffLevelList({ current: -1 })
      dataList.value = res.list || res.data || []
    }

    const handleAdd = () => {
      currentEditId.value = null
      formData.value = getDefaultFormData()
      levelIconFileList.value = []
      showForm.value = true
    }

    const handleEdit = (item) => {
      currentEditId.value = item.id
      formData.value = {
        levelName: item.levelName,
        levelIcon: item.levelIcon,
        skillCertification: item.skillCertification,
        targetConsumeIncome: item.targetConsumeIncome,
        targetActiveCustomers: item.targetActiveCustomers,
        targetCardIncome: item.targetCardIncome,
        benefits: item.benefits ? [...item.benefits] : []
      }
      levelIconFileList.value = item.levelIcon ? [{ url: item.levelIcon }] : []
      showForm.value = true
    }

    const handleCancel = () => {
      showForm.value = false
    }

    const handleSubmit = () => {
      formRef.value.validate(async (valid) => {
        if (!valid) return
        if (currentEditId.value) {
          let res = await updateStaffLevel({ id: currentEditId.value, ...formData.value })
          if (res.code == 0) {
            ElMessage.success('编辑成功!')
            showForm.value = false
            getDataList()
          }
        } else {
          let res = await saveStaffLevel(formData.value)
          if (res.code == 0) {
            ElMessage.success('添加成功!')
            showForm.value = false
            getDataList()
          }
        }
      })
    }

    const handleDelete = (item) => {
      popup('确认删除该等级信息吗?', async () => {
        let res = await deleteStaffLevel(item.id)
        if (res.code == 0) {
          ElMessage.success('删除成功!')
          getDataList()
        }
      })
    }

    getDataList()

    return {
      dataList,
      showForm,
      formRef,
      formData,
      formRules,
      benefitDialogVisible,
      newBenefit,
      handleAdd,
      handleEdit,
      handleCancel,
      handleSubmit,
      handleDelete,
      handleAddBenefit,
      confirmAddBenefit,
      removeBenefit,
      uploadIconRef,
      levelIconFileList,
      handleIconUploadSuccess,
      handleIconUploadRemove
    }
  }
})
</script>

<style scoped lang="less">
.level-management {
  .level-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0 20px;

    .level-title {
      font-size: 18px;
      font-weight: bold;
    }
  }

  .level-content {
    min-height: 60vh;
    padding: 20px 0;

    .box_list {
      display: flex;
      flex-wrap: wrap;
      margin-left: 15px;

      .box_item {
        width: 220px;
        border: 2px solid #efefef;
        border-radius: 8px;
        box-shadow: 0px 0px 10px #efefef;
        margin-right: 20px;
        margin-bottom: 20px;

        .title {
          text-align: center;
          padding: 15px 0;
          font-size: 16px;
        }

        .icon {
          width: 80px;
          height: 80px;
          margin: 0 auto;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .line {
          width: 88%;
          height: 2px;
          background-color: #efefef;
          margin: 10px auto 0;
        }

        .bottom_msg {
          width: 88%;
          margin: 0 auto;
          display: flex;
          font-size: 13px;
          color: #999;
          justify-content: space-between;
          margin-top: 12px;
        }

        .bottom_line {
          margin: 12px auto 0;
          height: 1px;
          background-color: #efefef;
        }

        .bottom_btns {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;

          .btn {
            width: 48%;
            text-align: center;
            height: 38px;
            line-height: 38px;
            color: #999;
            cursor: pointer;
          }

          .center_line {
            height: 38px;
            background-color: #efefef;
            width: 1px;
          }

          .btn.edit {
            color: #7948ea;
          }
        }
      }
    }
  }

  // 表单页样式
  .form-page {
    background-color: #fff;
    padding: 30px 40px;

    .section {
      margin-bottom: 30px;

      .section-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 20px;
      }

      .section-desc {
        font-size: 13px;
        color: #999;
        margin-bottom: 16px;
      }
    }


    .benefits-list {
      display: flex;
      flex-wrap: wrap;
      gap: 16px;

      .benefit-item {
        width: 160px;
        height: 80px;
        border: 1px solid #efefef;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        cursor: default;

        .benefit-name {
          font-size: 14px;
          color: #333;
        }

        .benefit-tag {
          font-size: 12px;
          color: #999;
          margin-top: 4px;
        }

        .benefit-remove {
          position: absolute;
          top: 4px;
          right: 4px;
          cursor: pointer;
          color: #999;
          font-size: 14px;

          &:hover {
            color: #f56c6c;
          }
        }
      }

      .add-benefit {
        border: 1px dashed #ccc;
        cursor: pointer;
        color: #999;

        &:hover {
          border-color: #7948ea;
          color: #7948ea;
        }
      }
    }

    .form-footer {
      display: flex;
      justify-content: flex-end;
      padding-top: 20px;
      border-top: 1px solid #efefef;
    }
  }
}
</style>
